module.exports = __webpack_public_path__ + "static/img/scene1.9f1e2809.jpg";